import { render, staticRenderFns } from "./WhichComponent.vue?vue&type=template&id=15c0c6ae&"
import script from "./WhichComponent.vue?vue&type=script&lang=js&"
export * from "./WhichComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports